var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagDeCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#000",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2C2C2C",
  d: "M26-.444C26-1.856 24.466-3 22.575-3H2.425C.536-3-.998-1.856-1-.444V7h27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BC2933",
  d: "M-.26 7v10h26V7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F6D340",
  d: "M26 24.444V17H-1v7.444c0 .678.36 1.328 1.002 1.807.643.48 1.514.749 2.422.749h20.152C24.467 27 26 25.855 26 24.444"
}))));
export { SvgFlagDeCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTEiIGZpbGw9IiMwMDAiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8bWFzayBpZD0iYSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB4PSIwIiB5PSIwIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBzdHlsZT0ibWFzay10eXBlOmx1bWluYW5jZSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTEiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8L21hc2s+CiAgICA8ZyBtYXNrPSJ1cmwoI2EpIj4KICAgICAgICA8cGF0aCBmaWxsPSIjMkMyQzJDIiBkPSJNMjYtLjQ0NDMxOUMyNS45OTkyLTEuODU1OTUgMjQuNDY1OC0zIDIyLjU3NDUtM0gyLjQyNTU0Qy41MzQyMDEtMy0uOTk5MjQxLTEuODU1OTUtMS0uNDQ0MzJWN2gyN1YtLjQ0NDMxOVoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQkMyOTMzIiBkPSJNLS4yNTk4NCA3djEwSDI1Ljc0MDJWN0gtLjI1OTg0WiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkQzNDAiIGQ9Ik0yNiAyNC40NDM2VjE3SC0xdjcuNDQzNmMtLjAwMDM3LjY3NzkuMzYwMjMxIDEuMzI4MSAxLjAwMjQyNTcgMS44MDc2Qy42NDQ2MiAyNi43MzA2IDEuNTE1NzggMjcgMi40MjQxNiAyN0gyMi41NzU4QzI0LjQ2NzIgMjYuOTk5NCAyNiAyNS44NTUgMjYgMjQuNDQzNiIvPgogICAgPC9nPgo8L3N2Zz4K";